import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import PageTitle from "../components/pagetitle";
import PrivacyPolicyDescription from "../components/PrivacyPolicy";
import Footer from "../components/footer/footer";
import Scrollbar from "../components/scrollbar";
import data from "../assets/data.json";

const PrivacyPolicyPage = () => {
  const location = useLocation();

  const baseURL = location.pathname.split("/")[1];

  const pageData = data[baseURL];
  return (
    <>
      <Navbar />
      <PageTitle backgroundClassName={"donate"} title={pageData.title} />
      <PrivacyPolicyDescription
        title={pageData.title}
        description={pageData.description}
      />
      <Footer />
      <Scrollbar />
    </>
  );
};
export default PrivacyPolicyPage;
